<template>
  <div>
    <div class="side-panel" style="display: flex; align-items: center">
      <img src="/segg.png" class="w-14" style="margin-right: 20px" />
      <h2 class="panel-title" style="font-size: 28px; font-weight: bold">
        Sistema Preditivo de Segurança Pública
      </h2>
    </div>

    <div class="menu">
      <button :class="{ active: isActiveMap }" @click="changeView('map')">Mapa Preditivo</button>
      <button :class="{ active: isActiveStatistics }" @click="changeView('statistics')">
        Estatísticas
      </button>
      <!-- <button :class="{ active: isActiveReports }" @click="changeView('reports')">Relatórios</button> -->
    </div>

    <div v-if="currentView === 'map'">
      <Map
        :securitySearch="securitySearch"
        :occurrences="occurrences"
        :types="types"
        :listinsights="listinsights"
        :municipalGuard="municipalGuard"
        :federalPoliceStation="federalPoliceStation"
        :superuser="superuser"
      />
    </div>
    <div v-else-if="currentView === 'statistics'">
      <Estat
        :percentSecuritySearch="percentSecuritySearch"
        :occurrencesPerTypeAndMonth="occurrencesPerTypeAndMonth"
        :genders="genders"
        :ages="ages"
        :victimsByRegion="victimsByRegion"
      />
    </div>
    <!--<div v-else-if="currentView === 'reports'">
      <Reports />
    </div>-->

    <div class="insights-bar" @click="toggleInsightsPanel">
      <img src="ins.png" alt="Logo" style="width: 180px; margin-right: 10px" />
      <img
        src="lamp-icon.png"
        alt="Ícone"
        style="width: 15px; height: 15px; margin-left: 10px; margin-top: 10px"
      />
      <span style="font-size: 14px; margin-top: 10px; margin-left: 5px; margin-right: 10px"
        >{{ listinsights.length }}
        {{ listinsights.length > 0 ? 'recomendações' : 'recomendação' }}</span
      >
    </div>

    <div v-if="showInsightsPanel" class="insights-panel">
      <span class="close-button" @click="closeInsightsPanel">X</span>
      <img src="i-SET.png" alt="Logo" style="width: 180px; margin-right: 10px" />
      <p style="font-weight: bold; font-size: 18px; margin-top: 30px">Insights</p>

      <!-- Novo painel adicionado abaixo -->
      <div>
        <div v-for="insight in insights" :key="insight.id" class="sub-panel">
          <div class="info-container">
            <img src="lamp-icon.png" alt="Some Image" class="info-image" style="width: 20px" />
            <strong class="info-text">{{ insight.title }}</strong>
          </div>
          <div class="button-container">
            <button
              style="margin-top: 10px"
              class="open-button"
              @click="openContainers(insight.id)"
            >
              Abrir
            </button>
          </div>
        </div>

        <div class="containers" :class="{ visible: isOpen }">
          <img
            src="i-SET.png"
            alt="Logo"
            style="width: 180px; margin-right: 10px; margin-left: 30px"
          />
          <div class="header-container">
            <h2 style="font-size: 24px; font-weight: bold">Análise do SET</h2>
            <button class="update-button" @click="updateInsight">Atualizar</button>
          </div>
          <div style="margin-top: 30px; margin-left: 30px; margin-right: 45px">
            <p class="containers-answer">Insight considerando os últimos 30 dias.</p>
          </div>

          <button class="close-button" @click="closeContainer">X</button>
          <div v-if="!loading" style="overflow-y: scroll; height: 80%">
            <div class="containers-content">
              <p class="containers-title">
                <strong>{{ insightSelected.title }}</strong>
              </p>
              <div
                v-if="insightSelected.answer"
                v-html="parseEnumeratedAnswer(insightSelected.answer).join('')"
              ></div>
            </div>
          </div>

          <div v-else class="skeleton" style="margin: 1rem 30px">
            <p class="containers-title">&nbsp;</p>
            <p class="containers-text">&nbsp;</p>
            <p class="containers-answer">&nbsp;</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from './Layout.vue'
import Estat from './Statistics.vue'
// import Reports from './Reports.vue'
import Map from './Map.vue'
import axios from 'axios'

export default {
  components: {
    Map,
    Estat,
    //Reports,
  },
  layout: Layout,
  props: {
    occurrences: {
      type: Array,
      default: () => [],
    },
    occurrencesPerTypeAndMonth: {
      type: Object,
      default: () => {},
    },
    municipalGuard: {
      type: Array,
      default: () => [],
    },
    federalPoliceStation: {
      type: Array,
      default: () => [],
    },
    securitySearch: {
      type: Array,
      default: () => [],
    },
    percentSecuritySearch: {
      type: Object,
      default: () => {},
    },
    genders: {
      type: Object,
      default: () => {},
    },
    victimsByRegion: {
      type: Object,
      default: () => {},
    },
    ages: {
      type: Object,
      default: () => {},
    },
    listinsights: {
      type: Array,
      default: () => [],
    },
    types: {
      type: Array,
      default: () => [],
    },
    superuser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentView: 'map',
      showInsightsPanel: false,
      selectedButton: null,
      isOpen: false,
      loading: false,
      insights: this.listinsights,
      insightSelected: { id: '', title: '', text: '', answer: '' },
      isActiveMap: true,
      isActiveStatistics: false,
      isActiveReports: false,
    }
  },
  methods: {
    extractTitle(text) {
      const pattern = /<title>(.*?)<\/title>/
      const matches = text.match(pattern)
      return matches ? matches[1] : null
    },
    parseEnumeratedAnswer(answer) {
      const regex = /\d+\s*-\s*[^;]+;/g
      let match
      const results = []

      while ((match = regex.exec(answer)) !== null) {
        results.push(match[0].trim())
      }

      if (results.length === 0) {
        return [answer]
      }

      return results.map((item) => `<p class="containers-answer">${item}</p>`)
    },
    changeView(view) {
      switch (view) {
        case 'map':
          this.isActiveMap = true
          this.isActiveStatistics = false
          this.isActiveReports = false
          break
        case 'statistics':
          this.isActiveStatistics = true
          this.isActiveMap = false
          this.isActiveReports = false
          break
        case 'reports':
          this.isActiveReports = true
          this.isActiveStatistics = false
          this.isActiveMap = false
          break
      }
      this.currentView = view
    },
    toggleInsightsPanel() {
      this.showInsightsPanel = !this.showInsightsPanel
    },
    closeInsightsPanel() {
      this.showInsightsPanel = false
    },
    async updateInsight() {
      this.loading = true
      try {
        const resp = await axios.get('/security-insights/interaction-chat-GPT', {
          params: { id: this.insightSelected.id },
        })
        console.log(resp)
        this.insightSelected = resp.data
        this.insightSelected.title = this.extractTitle(this.insightSelected.answer)
      } catch (error) {
        console.error('Error updating insight:', error)
      } finally {
        this.loading = false
      }
    },
    async openContainers(id) {
      this.isOpen = !this.isOpen
      this.loading = true
      try {
        const resp = await axios.get('/security-insights/interaction-chat-GPT', {
          params: { id: id },
        })
        console.log(resp)
        this.insightSelected = resp.data
        this.insightSelected.title = this.extractTitle(this.insightSelected.answer)
      } catch (error) {
        console.error('Error fetching insight:', error)
      } finally {
        this.loading = false
      }
    },
    closeContainer() {
      this.isOpen = false
    },
  },
}
</script>
<style>
.header-container {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.update-button {
  width: 90px;
  height: 40px;
  margin-left: 40px;
  background-color: #007bff;
  border: 2px solid #007bff;
  border-radius: 4px;
  color: #f9f9fa;
  cursor: pointer;
  outline: none;
  transition: border-color 0.8s;
}

.update-button:hover {
  border-color: #43b3ae;
}

.update-button:active {
  border-color: #43b3ae;
}
.menu {
  margin-left: 10px;
  margin-right: 10px;
  border-bottom: 1px solid #e6e9eb;
}

.menu button {
  margin-right: 50px;
  font-weight: bold;
  padding: 30px 0 20px;
}

.menu button.active {
  border-bottom: 3px solid #64b4c8;
}

.loading {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  color: #fff;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.date-button {
  background-color: rgba(217, 211, 211, 0.807);
  color: rgb(7, 7, 7);
  padding: 10px 20px;
  border: none;
  margin-right: 10px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 20px;
  margin-top: 20px;
}
.date-button:hover {
  opacity: 0.9;
  background-color: #43b3ae;
  color: white;
}
.white-panel {
  position: relative;
  background-color: white;
  width: 350px;
  height: 750px;
  left: 20;
  top: 30px;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
.export-button {
  background-color: #50acba;
  color: #fff;
  border: none;
  padding: 15px 25px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  position: absolute;
  top: 240px;
  right: 20px;
}
.insights-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9998;
}

.insights-panel {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 450px;
  background-color: #ffffff;
  color: rgb(52, 48, 48);
  padding: 10px;
  z-index: 9999;
  overflow-y: auto;
}

.insights-bar {
  position: fixed;
  display: flex;
  bottom: 0;
  right: 0;
  background-color: #1e2c4e;
  color: white;
  padding: 10px 10px;
  border-radius: 15px;
  cursor: pointer;
  z-index: 9999;
  width: 450px;
  height: 60px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.sub-panel-title {
  font-weight: bold;
  color: #333;
}
.open-button {
  background-color: #50acba;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 8px;
}
.sub-panel {
  background-color: #f7f3f3;
  padding: 15px;
  border-radius: 10px;
  margin-top: 20px;
}
.button-container {
  text-align: right;
  margin-top: -40px;
}
.info-text {
  margin-left: 15px;
  font-size: 14px;
  color: #50acba;
}
.info-container {
  display: flex;
  align-items: center;
}
.containers {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 600px;
  background-color: #fff;
  transition: transform 0.3s ease-in-out;
  transform: translateY(100%);
}

.containers-content {
  margin: 1rem 30px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1rem;
  margin-bottom: 50px;
}

.containers-text {
  border: 1px solid #eee;
  padding: 0.5rem;
  border-radius: 5px;
  margin-top: 1rem;
}

.containers-answer {
  border: 1px solid #64b4c8;
  padding: 0.5rem;
  border-radius: 5px;
  margin-top: 1rem;
  background-color: #f2fcff;
}

.skeleton .containers-title {
  height: 1.5rem;
  background-color: #eee;
  border-radius: 5px;
  animation-name: skeleton;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.skeleton .containers-text {
  height: 2rem;
  background-color: #eee;
  border-radius: 5px;
  animation-name: skeleton;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.skeleton .containers-answer {
  height: 3rem;
  background-color: #eee;
  border: none;
  animation-name: skeleton;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes skeleton {
  from {
    background-color: #eee;
  }
  to {
    background-color: #64b4c8;
  }
}

.visible {
  transform: translateY(0%);
}
.flex-container {
  padding-bottom: 50px;
}
/* Estilos para dispositivos móveis */
@media (max-width: 768px) {
  #mapes {
    width: 100%;
    height: 300px;
    float: none;
    margin-top: 20px;
  }

  .date-buttons {
    flex-direction: column;
  }

  .date-button {
    margin-bottom: 10px;
    width: 100%;
  }

  .search-boxs {
    width: 100%;
    right: 0;
    left: 0;
    margin: auto;
  }

  .accordion {
    margin-top: 10px;
  }

  .white-panel {
    display: block;
    width: 100%;
  }
}

/* Estilos para tablets */
@media (min-width: 769px) and (max-width: 1024px) {
  #mapes {
    width: 100%;
    height: 500px;
  }

  .date-buttons {
    flex-direction: row;
  }

  .date-button {
    width: auto;
  }

  .search-boxs {
    width: 50%;
  }
}

.date-button {
  flex-grow: 1;
  text-align: center;
}
</style>
